export default{
  remoteHost: (process.env.NODE_ENV === 'development' || location.host.indexOf('.test.') >= 0) ? 'https://www.mondocheckin.com/portal/' : 'https://www.mondocheckin.com/portal/',
  basicURL: process.env.NODE_ENV === 'development' ? '' : '',
  ewayEncryptKey: 'kDx5k07BO5AutY2xNBc09ZF50qyrzIFimjLIqShHUJII0QVPp4uK6YF3QmHg15CLZE0RtqDgMxpqYcYG6wtlwK5b2Zi7mTpyQYV+uf7oqupuq7P0yMt0v3wJTM9EymG+ntV3N34oohArgGznyLAuAU/P6O7gLE1ong5oD9KymNMyk4k2Jy2bH1Qanw8MFE7nX+w39urTPi6JD7aFixJdVAltVnbCLnS412+KR5/9H6ySXqepwFrxupj2xBgfToTUYI8FANq9cnF/yH0nPo14o8AWg0mxDic8BVjar/nC5QzHvw4krsJgZSqYPbsoTBtSua+jm6+g1Hg8xVXV36yt8Q==',
  userToken: 'accessToken'
}



// WEBPACK FOOTER //
// ./src/config/settings.js